/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import { string, number, date, array, object } from './utils'

export const postpoorList = {
  Req: {},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postaddPoor = {
  Req: {
    "yearPoorId": String,
    "logYear": {
        "type": String,
        "required": true
    },
    "reportDate": Date,
    "incomeOrigin": String,
    "avgIncome": String,
    "capitaMonthlyIncome": String,
    "gender": Number,
    "nation": String,
    "birthday": Date,
    "idCardNum": String,
    "maritalState": String,
    "political": String,
    "education": String,
    "joinPartyDate": Date,
    "partyDuty": String,
    "isFloatPartyMember": String,
    "joinGhDate": Date,
    "ghDuty": String,
    "phone": String,
    "email": String,
    "familyAddr": String,
    "familyPopulation": Number,
    "difficultSubject": String,
    "poorType": String,
    "poorReason": String,
    "poorDesc": String,
    "threeYearsDesc": String,
    "isPoor": String,
    "poorLevel": String,
    "orgEvalCondition": String,
    "isNwbrc": String,
    "isSubsidy": String,
    "healthCondition": String,
    "isLowerEnsure": String,
    "helpCategory": String,
    "poorSupply": String,
    "helpStep": String,
    "notPoor": Number,
    "notPoorTime": Date,
    "notPoorWay": String,
    "yearPoorFile": String,
    "knLevel": String,
    "cpcYearPoorFamilyList": Array,
    "cpcYearPoorFamilyList[0]": Object,
    "cpcYearPoorFamilyList[0].familyMemberId": String,
    "cpcYearPoorFamilyList[0].familyTies": String,
    "cpcYearPoorFamilyList[0].yearPoorId": String,
    "cpcYearPoorFamilyList[0].memberName": String,
    "cpcYearPoorFamilyList[0].memberSex": String,
    "cpcYearPoorFamilyList[0].memberAge": Number,
    "cpcYearPoorFamilyList[0].workUnit": String,
    "cpcYearPoorFamilyList[0].monthAvgIncome": String,
    "cpcYearPoorFamilyList[0].idCardNum": String,
    "cpcYearPoorFamilyList[0].nation": String,
    "cpcYearPoorFamilyList[0].education": String,
    "cpcYearPoorFamilyList[0].political": String,
    "cpcYearPoorFamilyList[0].phone": String,
    "cpcYearPoorFamilyList[0].birthday": Date,
    "cpcYearPoorFamilyList[0].familyMemberHealthy": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postreportPoor = {
  Req: {
    "yearPoorId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postgetPoor = {
  Req: {
    "yearPoorId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postlistHelp = {
  Req: {
    "yearPoorId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postdeletePoor = {
  Req: {},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}